import { render, staticRenderFns } from "./tableAutoScroll.vue?vue&type=template&id=7647968f&scoped=true&"
import script from "./tableAutoScroll.vue?vue&type=script&lang=js&"
export * from "./tableAutoScroll.vue?vue&type=script&lang=js&"
import style0 from "./tableAutoScroll.vue?vue&type=style&index=0&id=7647968f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7647968f",
  null
  
)

export default component.exports